module.exports = __webpack_public_path__ + "media/theme/sample__recochoku-a02cadbd.png";